export class Pessoa {
  idPessoa: number;
  nome: string;

  constructor(id: number, nome: string) {
    this.idPessoa = id;
    this.nome = nome;
  }
}
